// src/utils/parseFrontmatter.js
export default function parseFrontmatter(md) {
    const match = md.match(/^---\s*([\s\S]*?)\s*---\s*/);
    if (!match) return { data: {}, content: md };
    const yaml = match[1];
    const content = md.slice(match[0].length);
    const data = Object.fromEntries(
      yaml.split('\n').filter(Boolean).map(line => {
        const [k, ...rest] = line.split(':');
        // Value: Join, trim, und Quotation Marks entfernen
        let value = rest.join(':').trim();
        if (
          (value.startsWith('"') && value.endsWith('"')) ||
          (value.startsWith("'") && value.endsWith("'"))
        ) {
          value = value.slice(1, -1);
        }
        return [k.trim(), value];
      })
    );
    return { data, content };
  }
  